import Container from "../UI/Container/Container";
import Layout from "../UI/Layout/Layout";
import "./legal.css";

const Impressum = () => {
  return (
    <Layout authLevelRequired={false}>
      <Container>
        <div className="legal-text my-5 md:my-24">
          <h1>Impressum</h1>
          <p>Angaben gemäß TMG, §§ 2, 3 DL-Info V:</p>
          <p className="bold">Diensteanbieter i.S.v. § 5 TMG:</p>

          <p>Wilms Rechtsanwälte GbR</p>
          <p>vertreten durch die geschäftsführenden Gesellschafter:</p>
          <p>Rechtsanwalt Diedrich Wilms</p>
          <p>Rechtsanwalt Friedrich Schulze</p>
          <p>Rechtsanwältin Kathrin Freist</p>
          <p>Rechtsanwalt Felix Freist</p>
          <p className="bold">Kontaktdaten:</p>
          <p>Alt-Tempelhof 37/41</p>
          <p>12103 Berlin</p>
          <p>Tel.: +49 30 75 79 64 0</p>
          <p>Fax: +49 30 75 79 64 8</p>
          <p>
            E-Mail: <a href="mailto:rae@wilms.eu">rae(at)wilms.eu</a>
          </p>
          <p>Website: www.wilms.eu</p>
          <p className="bold">Umsatzsteueridentifikationsnummer:</p>
          <p>DE 114103514</p>
          <p className="bold">Inhaltlich Verantwortlicher:</p>
          <p>Rechtsanwalt Diedrich Wilms, Alt-Tempelhof 37/41, 12103 Berlin</p>
          <p>
            Die Rechtsanwältinnen und Rechtsanwälte von WILMS Rechtsanwälte sind
            Mitglieder der Rechtsanwaltskammer Berlin, Littenstraße 9 10179
            Berlin. Die Berufsbezeichnung „Rechtsanwalt“/“Rechtsanwältin“ wurde
            in der Bundesrepublik Deutschland verliehen.
          </p>
          <p>Für unsere anwaltliche Tätigkeit gelten</p>
          <p>- die Bundesrechtsanwaltsordnung (BRAO),</p>
          <p>- das Rechtsanwaltsvergütungsgesetz (RVG)</p>
          <p>- die Berufsordnung für Rechtsanwälte (BORA) sowie</p>
          <p>- die Fachanwaltsordnung (FAO).</p>

          <p>
            Die aktuellen berufsrechtlichen Regelungen sind auf der Website der
            Rechtsanwaltskammer Berlin abrufbar.
          </p>

          <p>Berufshaftpflichtversicherung:</p>
          <p>
            Allianz SE, Königinstraße 28, 80802 München, Räumlicher
            Geltungsbereich: Europa
          </p>

          <p>
            Plattform der EU-Kommission zur Online-Streitbeilegung:
            www.ec.europa.eu/consumers/odr
          </p>
          <p>
            Wir nehmen an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle nicht teil und sind hierzu auch nicht
            gesetzlich verpflichtet.
          </p>
        </div>
      </Container>
    </Layout>
  );
};

export default Impressum;
